import React from 'react';
import { useLocation } from 'react-router-dom';
import ActivatedUser from './ActivatedUser';
import ResetPassword from './ResetPassword';

const CommonActivationLink = () => {
  const location = useLocation();

  const isResetPasswordPath = location.pathname.includes('/resetpassword/updatepassword');

  return isResetPasswordPath ? <ResetPassword /> : <ActivatedUser />;
};

export default CommonActivationLink;
